import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FeatureServiceFormComponent} from '@catmodules/models/feature-services/components/feature-service-form/feature-service-form.component';
import {FeatureServicesService} from '@catmodules/models/feature-services/services/feature-services.service';
import {ServicesModule} from '@catmodules/models/services/services.module';
import {UnitsModule} from '@catmodules/models/units/units.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [
  FeatureServiceFormComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIFormModule,
  UIBaseModule,
  UnitsModule,
  ServicesModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureServicesService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureServicesModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-services/feature-services.module.ts